import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authenticated } from "@containers/Auth/store/selectors";
import { actions as sharedActions, selectors as sharedSelectors } from "@shared/store";
import { LoadingIndicator } from "@shared/components";

export const OAuthGuard: React.FC = () => {
  const dispatch = useDispatch();
  const params = useOauthParameters();
  const isAuthenticated = useSelector(authenticated());
  const authorizationCode = useSelector(sharedSelectors.getOAuthAuthorizationCode());

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(sharedActions.oauthAuthorize.request({ scope: params.scope, client_id: params.client_id }));
    }
  }, [dispatch, isAuthenticated, params]);

  useEffect(() => {
    if (authorizationCode) {
      const redirectUrl = new URL(params.redirect_uri);
      if (params.state) {
        redirectUrl.searchParams.set("state", params.state);
      }

      redirectUrl.searchParams.set("code", authorizationCode);

      window.location.href = redirectUrl.toString();
    }
  }, [authorizationCode, params]);

  return <LoadingIndicator />;
};

const useOauthParameters = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    return {
      client_id: searchParams.get("client_id") ?? "",
      scope: searchParams.get("scope") ?? "profile",
      redirect_uri: new URL(searchParams.get("redirect_uri") ?? ""),
      state: searchParams.get("state") ?? "",
    };
  }, [searchParams]);
};
